import {
GET_IS_ACCEPT  ,     
GET_IS_PO_ACCEPT ,   
SET_IS_ACCEPT    ,   
SET_IS_PO_ACCEPT    
} from "./actionTypes";




export function setIsAcceptAction(isActive){
  return function (dispatch) {
      dispatch({
        type: SET_IS_ACCEPT,
        payload:isActive
      })
    }
}

export function setIsPoAcceptAction(isActive){
  return function (dispatch) {
    
      dispatch({
        type: SET_IS_PO_ACCEPT,
        payload:isActive
      })
    }
}

export function getIsAcceptAction(){
  return function(dispatch){
    dispatch({
      type : GET_IS_ACCEPT,
    })
  }
}
export function getIsPoAcceptAction(){
  return function(dispatch){
    dispatch({
      type : GET_IS_PO_ACCEPT,
    })
  }
}

// export function getAllUnitReviewerAction(unit_code) {
//   return function (dispatch) {
//       dispatch({
//           type: START_LOADING
//       })

//       try {
//           let promise = axios({
//               headers: {...authHeader(),'Pragma': 'no-cache'},
//               method: "post",
//               url: `${AppSettings.apiUrl}/api/User/GetAllUnitReviewer`,
//               params: {
//                 unit_code : unit_code
//             }
//           })

//           promise.then(response => {
//               dispatch({
//                   type: GET_ALL_UNIT_REVIEWER,
//                   payload: response.data,
//               });
//               dispatch({
//                   type: STOP_LOADING
//               });
//           }
//           );

//           return promise
//       } catch (error) {
//           dispatch({
//               type: STOP_LOADING
//           })

//       } finally {
//       }
//   }
// }
